import React, { useContext, useLayoutEffect } from 'react'
import { useLoaderData } from 'react-router'
import gql from 'graphql-tag'
import { useQuery } from 'urql'
import { lensPath, pipe, set } from 'ramda'
import PageNavContainer from '../../../state/PageNavContainer'
import OldAppHeader from '../../AppModule/App/OldAppHeader'
import HubDbasQuizResultsPage from './HubDbasQuizResultsPage'
import LoadOverlay from '../../shared/LoadOverlay'
import RoutingContext from '../../../context/RoutingContext'

// -----------------------------------------------------------------------------
// Query
// -----------------------------------------------------------------------------

const CurrentEnrolmentForLatestDbasResult = gql`
  query latestDbasResult {
    currentEnrolment {
      id
      latestDbasResult: latestQuestionnaireResult(key: "dbas") {
        id
        maximumScore
        result
        score
        stepResponses {
          nodes {
            id
            score
            value
            step {
              category
              defaultNextStepId
              id
              contents {
                nodes {
                  id
                  key
                  value
                  valueType
                }
              }
            }
          }
        }
      }
    }
  }
`

// -----------------------------------------------------------------------------
// Const
// -----------------------------------------------------------------------------

const PAGE_ID = `hub-dbas-quiz-results`

// -----------------------------------------------------------------------------
// Utils
// -----------------------------------------------------------------------------

const setPagesHubSleepCoachesCardLinkUrl = set(
  lensPath([`page`, `content`, `sleepCoachesCard`, `link`, `url`])
)

const injectRouting = (routing, content) =>
  pipe(setPagesHubSleepCoachesCardLinkUrl(routing.chatMessagesPath))(content)

// -----------------------------------------------------------------------------
// Component
// -----------------------------------------------------------------------------

const HubDbasQuizResultsModule = () => {
  const loaderData = useLoaderData()
  const [, setNav] = PageNavContainer.useContainer()
  const { appRouting } = useContext(RoutingContext)
  const loaderDataWithRouting = injectRouting(appRouting, loaderData)
  const [result] = useQuery({
    query: CurrentEnrolmentForLatestDbasResult,
    variables: [],
    requestPolicy: `network-only`,
  })

  const { data, error } = result

  useLayoutEffect(() => {
    setNav({
      pageId: PAGE_ID,
      Header: OldAppHeader,
    })
  }, [setNav])

  return !data || error ? (
    <LoadOverlay />
  ) : (
    <HubDbasQuizResultsPage
      content={loaderDataWithRouting.page.content}
      results={data.currentEnrolment.latestDbasResult}
    />
  )
}

export default HubDbasQuizResultsModule
